import { AdminPanelSettings, Code, Person, WorkspacePremium, Assessment, AccountBalance } from '@mui/icons-material';
import { ModeConfig, SidebarMode } from './sidebar.types';
import { sidebar } from '@/styles/tokens';

export const MODES: Record<SidebarMode, ModeConfig> = {
  general: {
    key: 'general',
    label: 'sidebar.mode.general',
    bgColor: sidebar.lightBg,
    textColor: sidebar.lightText,
    icon: <Person />,
    allowedRoles: [],
  },
  client: {
    key: 'client',
    label: 'sidebar.mode.client',
    bgColor: sidebar.lightBg,
    textColor: sidebar.lightText,
    icon: <Person />,
    allowedRoles: ['client'],
  },
  expert: {
    key: 'expert',
    label: 'sidebar.mode.expert',
    bgColor: sidebar.expertBg,
    textColor: sidebar.lightText,
    icon: <WorkspacePremium />,
    allowedRoles: ['expert'],
  },
  admin: {
    key: 'admin',
    label: 'sidebar.mode.admin',
    bgColor: sidebar.adminBg,
    textColor: sidebar.darkText,
    icon: <AdminPanelSettings />,
    allowedRoles: ['superadmin', 'admin'],
  },
  developer: {
    key: 'developer',
    label: 'sidebar.mode.developer',
    bgColor: sidebar.developerBg,
    textColor: sidebar.darkText,
    icon: <Code />,
    allowedRoles: ['developer'],
  },
  pm: {
    key: 'pm',
    label: 'sidebar.mode.pm',
    bgColor: sidebar.pmBg,
    textColor: sidebar.darkText,
    icon: <Assessment />,
    allowedRoles: ['pm'],
  },
  owner: {
    key: 'owner',
    label: 'sidebar.mode.owner',
    bgColor: sidebar.ownerBg,
    textColor: sidebar.darkText,
    icon: <AccountBalance />,
    allowedRoles: ['owner'],
  },
};

export const ALL_MODES: SidebarMode[] = ['general', 'client', 'expert', 'admin', 'developer', 'pm', 'owner'];
